/** 
 * © 2025 COMPUTACIÓN EN ACCIÓN, S.A. DE C.V. 'CONTPAQi'. Todos los derechos reservados. 
 * Este código fuente constituye una obra original protegida por la legislación nacional e internacional en materia de propiedad intelectual. 
 * Su reproducción, distribución, comunicación pública, transformación, descompilación, ingeniería inversa o cualquier uso no autorizado, 
 * total o parcial, se encuentra expresamente prohibido sin la previa autorización por escrito de COMPUTACIÓN EN ACCIÓN, S.A. DE C.V. 
 * El uso indebido de este software puede ser constitutivo de delitos y dará lugar a las responsabilidades civiles y penales correspondientes. 
*/ 
 
export const GET_ROLES = 'uiActionTypes/GET_ROLES';
export const GET_ROLES_SUCCESS = 'uiActionTypes/GET_ROLES_SUCCESS';
export const GET_ROLES_FAILURE = 'uiActionTypes/GET_ROLES_FAILURE';
export const DELETE_ROL = 'uiActionTypes/DELETE_ROL';
export const DELETE_ROL_SUCCESS = 'uiActionTypes/DELETE_ROL_SUCCESS';
export const DELETE_ROL_FAILURE = 'uiActionTypes/DELETE_ROL_FAILURE';
export const UPDATE_ROLES = 'uiActionTypes/UPDATE_ROLES';
export const UPDATE_ROLES_SUCCESS = 'uiActionTypes/UPDATE_ROLES_SUCCESS';
export const UPDATE_ROLES_FAILURE = 'uiActionTypes/UPDATE_ROLES_FAILURE';
export const SET_VIEW_COLUMNS = 'uiActionTypes/SET_VIEW_COLUMNS';
export const UPDATE_CURRENT_ROLES = 'uiActionTypes/UPDATE_CURRENT_ROLES';
export const UPDATE_ROL_ON_LIST = 'uiActionTypes/UPDATE_ROL_ON_LIST';
export const CLEAN_ROLES_ERRORS = 'uiActionTypes/CLEAN_ROLES_ERRORS';

export interface GetRoles {
  type: typeof GET_ROLES;
  payload?:any,
}

export interface GetRolesSuccess {
  type: typeof GET_ROLES_SUCCESS;
  payload?:any;
}

export interface GetRolesFailure {
  type: typeof GET_ROLES_FAILURE;
  payload?:any;
}

export interface DeleteRol {
  type: typeof DELETE_ROL;
  payload?:any,
}

export interface DeleteRolSuccess {
  type: typeof DELETE_ROL_SUCCESS;
  payload?:any;
}

export interface DeleteRolFailure {
  type: typeof DELETE_ROL_FAILURE;
  payload?:any;
}

export interface UpdateRol {
  type: typeof UPDATE_ROLES;
  payload?:any,
}

export interface UpdateRolSuccess {
  type: typeof UPDATE_ROLES_SUCCESS;
  payload?:any;
}

export interface UpdateRolFailure {
  type: typeof UPDATE_ROLES_FAILURE;
  payload?:any;
}
